import { useEffect, useRef } from "react";

export default function FluidCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let W = canvas.width  = window.innerWidth;
    let H = canvas.height = window.innerHeight;
    let mx = -999, my = -999;
    let raf;
    const particles = [];

    const COLORS = ["#D94F00", "#ff7a2f", "#ffb347", "#ff4500", "#ff6b35", "#ffd700"];

    class Particle {
      constructor(x, y) {
        this.x = x + (Math.random() - 0.5) * 8;
        this.y = y + (Math.random() - 0.5) * 8;
        this.vx = (Math.random() - 0.5) * 2.5;
        this.vy = (Math.random() - 0.5) * 2.5 - 0.8;
        this.alpha = 0.9 + Math.random() * 0.1;
        this.decay = 0.012 + Math.random() * 0.018;
        this.size = 2 + Math.random() * 4;
        this.color = COLORS[Math.floor(Math.random() * COLORS.length)];
        this.gravity = 0.04;
        this.wobble = Math.random() * Math.PI * 2;
        this.wobbleSpeed = 0.08 + Math.random() * 0.06;
      }
      update() {
        this.wobble += this.wobbleSpeed;
        this.vx += Math.sin(this.wobble) * 0.08;
        this.vy += this.gravity;
        this.x += this.vx;
        this.y += this.vy;
        this.alpha -= this.decay;
        this.size *= 0.985;
      }
      draw() {
        ctx.save();
        ctx.globalAlpha = Math.max(0, this.alpha);
        ctx.shadowBlur = 8;
        ctx.shadowColor = this.color;
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }

    let lastX = -999, lastY = -999;

    const onMove = (e) => {
      mx = e.clientX; my = e.clientY;
      const dist = Math.hypot(mx - lastX, my - lastY);
      const count = Math.min(Math.floor(dist * 0.5) + 3, 12);
      for (let i = 0; i < count; i++) particles.push(new Particle(mx, my));
      lastX = mx; lastY = my;
    };

    const onResize = () => {
      W = canvas.width  = window.innerWidth;
      H = canvas.height = window.innerHeight;
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("resize", onResize);

    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      for (let i = particles.length - 1; i >= 0; i--) {
        particles[i].update();
        particles[i].draw();
        if (particles[i].alpha <= 0) particles.splice(i, 1);
      }
      raf = requestAnimationFrame(draw);
    };

    draw();
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 3 }}
    />
  );
}
